import React, { useEffect, useRef, useState, useMemo } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './PortfolioStats.module.css';

const PortfolioStats = React.memo(() => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { data, t, formatNumber } = useLanguage();
  const { projects, skills, experience } = data;

  const stats = useMemo(() => [
    { value: projects.length, label: t('stats.projects'), icon: 'fas fa-rocket' },
    { value: skills.reduce((total, category) => total + category.skills.length, 0), label: t('stats.skills'), icon: 'fas fa-code' },
    { value: new Set(projects.flatMap(project => project.technologies)).size, label: t('stats.technologies'), icon: 'fas fa-layer-group' },
    { value: experience.length, label: t('stats.milestones'), icon: 'fas fa-award' }
  ], [projects, skills, experience, t]);

  useEffect(() => {
    const node = sectionRef.current;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.25 });
    if (node) observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={styles.statsSection} ref={sectionRef} aria-label={t('stats.eyebrow')}>
      <div className={styles.container}>
        <div className={styles.intro}>
          <span>{t('stats.eyebrow')}</span>
          <h2>{t('stats.title')}</h2>
        </div>
        <div className={styles.statsGrid}>
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={`${styles.statCard} ${isVisible ? styles.visible : ''}`}
              style={{ '--delay': `${index * 90}ms` }}
            >
              <i className={stat.icon} aria-hidden="true"></i>
              <strong>{formatNumber(stat.value)}<span>+</span></strong>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default PortfolioStats;
